import { logPageLoadTime, logUserBrowserAndDevice, logUserLanguage, logUserRegion } from "./emfLogs"
import { BrowserAndDevice } from "./loggerConstants"

export function getBrowser(userAgent) {
    let browser = BrowserAndDevice.Browsers.Unknown

    if (/firefox|fxios/i.test(userAgent)) {
        browser = BrowserAndDevice.Browsers.Firefox
    } else if (/edg/i.test(userAgent)) {
        browser = BrowserAndDevice.Browsers.Edge
    } else if (/googlebot|chrome|chromium|crios/i.test(userAgent) && !/opr|opera|edg|ucbrowser|samsungbrowser/i.test(userAgent)) {
        browser = BrowserAndDevice.Browsers.Chrome
    } else if (/safari|applewebkit/i.test(userAgent) && !/chrome|crios|opr|opera|fxios|firefox|edg|chromium|ucbrowser|samsungbrowser/i.test(userAgent)) {
        browser = BrowserAndDevice.Browsers.Safari
    } else if (/opr|opera/i.test(userAgent)) {
        browser = BrowserAndDevice.Browsers.Opera
    } else if (/samsungbrowser/i.test(userAgent)) {
        browser = BrowserAndDevice.Browsers.Samsung
    }

    return browser
}

export function getDevice(userAgent) {
    let device = BrowserAndDevice.Devices.Unknown

    if (/iPad/i.test(userAgent)) {
        device = BrowserAndDevice.Devices.iPad
    } else if (/iPhone/i.test(userAgent)) {
        device = BrowserAndDevice.Devices.iPhone
    } else if (/Android/i.test(userAgent)) {
        device = BrowserAndDevice.Devices.Android
    } else if (/Macintosh/i.test(userAgent)) {
        device = BrowserAndDevice.Devices.Macintosh
    } else if (/Windows/i.test(userAgent)) {
        device = BrowserAndDevice.Devices.Windows
    } else if (/Linux/i.test(userAgent)) {
        device = BrowserAndDevice.Devices.Linux
    }

    return device
}

var pageLoaded = false
export function pageLoadLogs(userAgent, page) {
    if (!pageLoaded) {
        logUserLanguage(digitalData.selectedLanguage)
        logUserRegion(digitalData.regRegion)
        logUserBrowserAndDevice(userAgent)
        logPageLoadTime(page)
        pageLoaded = true
    }
}
